export default "__VITE_ASSET__Dj8v15U8__"